import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CostCenterRoutingModule } from './commission-config-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { CommissionConfigComponent } from './commission-config.component';
import { UpdateCommissionConfigComponent } from './update-commission-config/update-commission-config.component'; 
import { CreateCommissionConfigComponent } from './create-commission-config/create-commission-config.component';
import { ViewCommissionConfigComponent } from './view-commission-config/view-commission-config.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';



@NgModule({
  declarations: [ CommissionConfigComponent , UpdateCommissionConfigComponent, CreateCommissionConfigComponent, ViewCommissionConfigComponent],
  imports: [
    CommonModule,
    SharedModule,
    CostCenterRoutingModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule,
    KeyboardShortcutsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule
  ]
})
export class CommissionConfigModule { }
